export default __webpack_public_path__ + "static/media/ColorHCPManagement.dd64619d.svg";